import React, {useState} from "react";
import {Modal, Spin} from "antd";
import {isFormComplete, notifyUser} from "../../../util/util";
import {serverRequest} from "../../../util/server_request";
import { useLocation, useNavigate } from 'react-router-dom';
import secureLocalStorage from "react-secure-storage";
import SuccessImg from "../../../assets/img/success-img.svg";

export const ValidateInfo = () => {
    const location = useLocation();
    // eslint-disable-next-line no-unused-vars
    const navigate = useNavigate();
    // eslint-disable-next-line no-unused-vars
    const phone = location.state?.phone;
    const employerNumber = location.state?.employerNumber;
    const [form, setForm] = useState({ email: '', taxNumber: '', registrationNumber: '' })
    const [loading, setLoading] = useState(false)
    const [isModal, setIsModal] = useState(false)

    const toggleLoading = () => setLoading(prevState => !prevState)
    const toggleModal = () => setIsModal(prevState => !prevState)

    const changeHandler = (e) => setForm({...form, [e.target.name]: e.target.value})

    const verifyInfo = () => {
        if (isFormComplete(form)){
            toggleLoading()
            serverRequest('POST', 'auth/verify/employer/details', {...form, employerNumber: employerNumber})
                .then(result => {
                    toggleLoading()
                    if (!result.success){
                        notifyUser('error', result.message, 'Error')
                    }else{
                        notifyUser('success', result.message, 'Success')
                        secureLocalStorage.setItem('email', form.email)
                        toggleModal()
                        // navigate('/onboard/create-password', {state: {phone, employerNumber, email: form.email}})
                        setForm({ email: '', taxNumber: '', registrationNumber: '' })
                    }
                }).catch(error => {
                toggleLoading()
                notifyUser('error', error.message, 'Error')
            })
        }else {
            notifyUser('error', 'All fields are required!', 'Validation Error')
        }
    }

    return (
        <div className='mx-auto mobile-full-width shadow bg-white p-5 rounded login-width'>
            <div align='center'>
                <p className='lead fw-bold'>Validate Your Details</p>

                <Spin spinning={loading}>
                    <div className="mt-4 w-75 mx-auto mobile-full-width">
                        <div className="mb-4"><omk-text-field label="Email" value={form.email} type='email' onInput={changeHandler} name='email' /></div>
                        <div className="mb-4"><omk-text-field label="Tax Number" value={form.taxNumber} type='text' onInput={changeHandler} name='taxNumber'/></div>
                        <div className="mb-5"><omk-text-field label="Registration Number" value={form.registrationNumber} type='text' onInput={changeHandler} name='registrationNumber'/></div>

                        <p className="text-center omk-text-small fw-bold">Need help?</p>
                        <p className="text-center omk-text-small text-black-50"><i className="bi bi-shield-lock"/> Your information is confidential and secure</p>
                        <button className="btn btn-primary mb-4 w-50 mobile-full-width" onClick={verifyInfo}>Continue</button>
                    </div>
                </Spin>
            </div>

            <Modal open={isModal} footer={null}>
                <div align='center' className='p-5'>
                    <p className='lead fw-bold'>Email verification sent!</p>
                    <small>Check your email address ({secureLocalStorage.getItem('email')}) provided to verify your account.</small>
                    <div className="mt-4 w-75 mx-auto mobile-full-width">
                        <img src={SuccessImg} alt='success onboard' className='img-fluid mb-5'/>
                        <button className="btn btn-primary mb-4 w-50 mobile-full-width" onClick={toggleModal}>Close</button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}